// import { AHeading, BHeading } from '@Layouts/Ir/Heading'
import { Fragment } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { Spacer } from '@/components/elements/Spacer'
// import { Paragraph } from '@/components/layouts/Ir/Paragraph'
import { PDFList } from '@/components/layouts/PublicNotice/PDFList'

import { Company, PublicNotice } from '@/types/publicNotice'

type Props = {
  company: Company
  bulletin: PublicNotice[]
  finalAccount: PublicNotice[]
}

export const PublicNoticePDF = ({ company, bulletin, finalAccount }: Props) => {
  return (
    <>
      <AHeading>{company.companyName}</AHeading>
      {company.comments && <Paragraph>{company.comments}</Paragraph>}
      {company.showBulletin && (
        <section>
          <SubHeading>公告事項</SubHeading>
          <Spacer h={{ sp: 20, pc: 36 }} />
          {bulletin.length > 0 ? (
            <>
              <ItemContainer key={bulletin[0].type.title}>
                {bulletin.map((item, index) => (
                  <Fragment
                    key={`${index}${item.company}${item.index}${item.title}`}
                  >
                    <PDFList
                      pdfList={[
                        {
                          id: item.pdf._id,
                          fileName: item.title,
                          filePath: item.pdf.src,
                        },
                      ]}
                    />
                  </Fragment>
                ))}
              </ItemContainer>
            </>
          ) : (
            <Paragraph>現在、公告すべき事項はございません。</Paragraph>
          )}
          <Spacer h={{ sp: 50, pc: 80 }} />
        </section>
      )}
      {company.showFinalAccounts && (
        <section>
          <SubHeading>決算公告</SubHeading>
          <Spacer h={{ sp: 20, pc: 36 }} />
          {company.finalAccountSummary && (
            <>
              <Paragraph>
                {company.finalAccountSummary.split('→').map((value, index) => (
                  <Fragment key={`${index}${value}`}>
                    {value}
                    <br />
                  </Fragment>
                ))}
              </Paragraph>
              <Spacer h={{ sp: 10, pc: 15 }} />
            </>
          )}
          {finalAccount.length > 0 ? (
            <>
              <ItemContainer key={finalAccount[0].type.title}>
                {finalAccount.map((item, index) => (
                  <Fragment
                    key={`${index}${item.company}${item.index}${item.title}`}
                  >
                    <PDFList
                      pdfList={[
                        {
                          id: item.pdf._id,
                          fileName: item.title,
                          filePath: item.pdf.src,
                        },
                      ]}
                    />
                  </Fragment>
                ))}
              </ItemContainer>
            </>
          ) : (
            <Paragraph>現在、決算公告事項はございません。</Paragraph>
          )}
          {company.finalAccountComments && (
            <>
              <Spacer h={{ sp: 10, pc: 15 }} />
              <Paragraph>
                {company.finalAccountComments.split('→').map((value, index) => (
                  <Fragment key={`${index}${value}`}>
                    {value}
                    <br />
                  </Fragment>
                ))}
              </Paragraph>
            </>
          )}
        </section>
      )}
    </>
  )
}

const SubHeading = styled.h3`
  font-size: 24px;
  font-weight: 700;
  line-height: 140%;
  color: ${theme.colors.trialBlue};

  @media screen and (max-width: 1047px) {
    font-size: 20px;
    line-height: 130%;
  }
`

const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 25.6px;
  color: ${theme.colors.textTitle};

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 24px;
  }
`

export const Paragraph = styled.p`
  font-size: 16px;
  line-height: 190%;

  @media screen and (max-width: 1047px) {
    font-size: 15px;
    line-height: 180%;
  }
`

export const AHeading = styled.h2`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  color: ${theme.colors.textTitle};
  border-bottom: 1px solid ${theme.colors.grey};
  padding-bottom: 22px;
  margin-bottom: 50px;

  @media screen and (max-width: 1047px) {
    font-size: 19px;
    padding-bottom: 10px;
    margin-bottom: 30px;
  }
`
